<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!consumableassetSelected) {
        <h1 class="title">Crear activo consumible</h1>
      }
    </div>
    <div class="title-color">
      @if (consumableassetSelected) {
        <h1 class="title">Editar activo consumible</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="consumableassetForm" (ngSubmit)="saveconsumableAsset()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="150"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (consumableassetForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (consumableassetForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 150 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Valor</mat-label>
              <input type="number" matInput placeholder="Valor" formControlName="value" />
              @if (consumableassetForm.get('value')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Unidad</mat-label>
              <mat-select placeholder="Unidad" formControlName="unity">
                @for (value of unityOptions; track value.value) {
                  <mat-option [value]="value.value">{{ value.label }}</mat-option>
                }
              </mat-select>
              @if (consumableassetForm.get('unity')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (consumableassetForm.get('unity')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 150 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Paquete</mat-label>
              <input type="number" matInput placeholder="Paquete" formControlName="package" />
              @if (consumableassetForm.get('package')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!consumableassetForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
